'use strict';

angular.module('app.performanceReportKPI', [])
    .directive('performanceReportKpiDirective', function () {
        return {
            controller: 'performanceReportKPICtrl',
            templateUrl: 'app/measure/performanceReport/performanceReportKPI/performanceReportKPI.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })